import { App } from './app.js';
import '../styles/main.css';

// Initialize the app when DOM is ready
document.addEventListener('DOMContentLoaded', async () => {
	const app = new App();
	await app.init();
});
